import type { VendorListDateSearchInput } from '@/generated/gql/graphql'

import { toDate } from 'date-fns-tz/toDate'
import { isValid } from 'date-fns/isValid'

export const normalizeUtcDateTimeString = (value?: string | null) => {
  if (typeof value !== 'string') return ''

  const normalizedValue = value.endsWith('UZ') ? `${value.slice(0, -2)}Z` : value
  const parsedDate = new Date(normalizedValue)

  return Number.isNaN(parsedDate.getTime()) ? '' : normalizedValue
}

export function getVendorSearchDateTime(value?: string | null): VendorListDateSearchInput | null {
  const normalized = normalizeUtcDateTimeString(value)
  if (!normalized) return null

  // Offset-free URL values represent UTC, regardless of the browser timezone.
  const isoDate = toDate(normalized, { timeZone: 'UTC' })
  // Preserve legacy native parsing, defaulting zone-less values to UTC as before.
  const hasLegacyTimezone = /\b(?:GMT|UTC|[ECMP][SD]T)\b|[+-]\d{2}:?\d{2}\b/i.test(normalized)
  const date = isValid(isoDate)
    ? isoDate
    : new Date(hasLegacyTimezone ? normalized : `${normalized} UTC`)
  if (!isValid(date)) return null

  return {
    date: date.getUTCDate(),
    month: date.getUTCMonth(),
    year: date.getUTCFullYear(),
    hour: date.getUTCHours(),
    minute: date.getUTCMinutes(),
    timezone: 'UTC',
  }
}
